var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiamondWobg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.881 8.06836L12 22.1373L24 8.06836H16.881Z",
    fill: "#FFE182"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96552 1.8623L0 8.06921H7.11895L4.96552 1.8623Z",
    fill: "#FFCD73"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8809 8.06921H23.9998L19.0343 1.8623L16.8809 8.06921Z",
    fill: "#FFCD73"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8812 8.06921L12.0002 1.8623L7.11914 8.06921H16.8812Z",
    fill: "#FFCD73"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 1.8623H4.96509L7.11853 8.06921L11.9996 1.8623Z",
    fill: "#FFAA64"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0345 1.8623H12L16.881 8.06921L19.0345 1.8623Z",
    fill: "#FFE182"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.11914 8.06836L12.0002 22.1373L16.8812 8.06836H7.11914Z",
    fill: "#FFAA64"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.06836L12 22.1373L7.11895 8.06836H0Z",
    fill: "#FF8C5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondWobg);
export default __webpack_public_path__ + "static/media/diamondWOBG.b7847f10.svg";
export { ForwardRef as ReactComponent };